<template>
  <div :class="{ 'reaction-star': true, 'reaction-container': true, 'reaction-empty': count == 0 }">
    <div :class="{ 'reaction-show': true, 'reaction-editable': canReact }" :title="title" @click="startReacting">
      <div class="reaction-stars">
        <base-icon v-if="count == 0" name="star_border" size="small" class="caption-type" />
        <base-icon
          v-for="fullStar in fullStarRange"
          :key="fullStar"
          name="star"
          size="small"
          :class="{ 'highlighted-icon': myReaction, 'caption-type': !myReaction }"
        />
        <base-icon
          v-if="halfStar"
          name="half_star"
          size="small"
          :class="{ 'highlighted-icon': myReaction, 'caption-type': !myReaction }"
        />
      </div>
      <span v-if="count > 0" key="count" class="reaction-star-count small-type caption-type">{{ count }}</span>
      <span
        v-if="canReact && !myReaction"
        key="starButton"
        role="button"
        class="small-buttony-caption-type strong-type reaction-action"
        >{{ p__('Assign a value', 'Rate') }}</span
      >
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapActions } from 'vuex'
import BaseIcon from 'vuecomponents/base_icon'
import IntlMixin from 'vuemixins/intl_mixin'
export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['isReactable', 'userId', 'reactionIds', 'reactions'],
  computed: {
    myReaction() {
      return this.reactionIds.filter((x) => this.reactions[x].user_id === this.userId)[0]
    },
    myRating() {
      return this.myReaction ? this.reactions[this.myReaction].value : 0
    },
    canReact() {
      return this.isReactable
    },
    count() {
      return this.reactionIds.length
    },
    title() {
      if (this.count === 0) return this.__('Be the first one to rate this post')
      let title = `${this.__('Avg rating')}: ${this.avgRating}`
      if (this.myRating) {
        title += ` • ${this.__('Your rating')}: ${this.myRating}`
      }
      return title
    },
    sumRating() {
      const sumReducer = (sum, id) => sum + this.reactions[id].value
      return this.reactionIds.reduce(sumReducer, 0)
    },
    avgRating() {
      if (this.count === 0) return null
      return (this.sumRating / this.count).toFixed(1)
    },
    halfStar() {
      if (this.count === 0) return false
      const decimal = this.avgRating - Math.floor(this.avgRating)
      return decimal <= 0.75 && decimal > 0.25
    },
    fullStarRange() {
      if (this.count === 0) return []
      const avg = parseFloat(this.avgRating) + 0.25
      return [1, 2, 3, 4, 5].filter((starValue) => starValue < avg)
    },
  },
  methods: {
    ...mapActions('snackbars', ['setSnackbar']),
    showReactionOffNotice() {
      const message = this.__('Reactions have been disabled by the admin.')
      this.setSnackbar({ message })
    },
    startReacting() {
      if (this.canReact) {
        this.$emit('edit')
      } else {
        this.showReactionOffNotice()
      }
    },
  },
}
</script>
